module.exports = __webpack_public_path__ + "img/img0.0f0929f3.jpg";